<template>
  <div class="">
    <Breadcrumb :title="$t('miga.SelectSlot')" />
    <HeadingBox
      :title="$t('selectslot.title')"
      :description="$t('selectslot.description')"
    />
    <DatosIntroducidos />

    <AlertaError />
    <Spinner v-show="loading" />

    <div v-show="!loading">
      <HeadingBox v-if="slots && !slots.length" :title="$t('sinresultados')" :description="$t('intentelomastarde')" />

      <div class="whitebox text-center" v-else>
        <div class="row">
          <div class="col-12 col-md-6 col-xl-3" v-for="s in days" :key="s" :aria-selected="filterDay === s">
            <a
              class="btn btn-raised btn-block m-2 p-1 seleccion-dia"
              style="width: 90%"
              tabindex="8"
              role="listbox"
              @click="setFilterDay(s)"
              @keyup.enter="setFilterDay(s)"
              :class="{
                'btn-upvehu-negro': filterDay === s,
                'btn-upvehu-blanco': filterDay !== s,
              }"
            >
              <span style="line-height: 2rem">{{ s | iso2shortdate }}</span>
              <span class="badge bg-secondary py-1 px-2 float-right"
                >{{ dayCounts[s] }} <br />
                {{ $t('disponibles') }}</span
              >
            </a>
          </div>
        </div>
      </div>

      <transition name="slide-fade">
        <div class="whitebox text-center mt-3" v-if="filterDay && filterHour != '*'" id="horas">
          <div class="row">
            <div
              class="col-12 col-md-6 col-lg-4 col-xl-3 mb-2"
              v-for="s in hourFilters"
              :key="s.label"
              :aria-selected="filterHour === s"
            >
              <a
                role="listbox"
                @click="setFilterHour(s)"
                @keyup.enter="setFilterHour(s)"
                tabindex="8"
                style="width: 90%"
                :class="{
                  'btn-upvehu-negro': filterHour === s,
                  'btn-upvehu-blanco': filterHour !== s,
                }"
                class="btn btn-raised mx-2 p-1 seleccion-hora"
              >
                <span style="line-height: 2rem">{{ s.label }}</span>
                <span class="badge bg-secondary py-1 px-2 mt-1 float-right"
                  >{{ hourCounts[+s.starts] }} <br />
                  disponibles</span
                >
              </a>
            </div>
          </div>
        </div>
      </transition>

      <transition name="slide-fade">
        <div class="whitebox text-center mt-3" v-if="(filterHour || {}).starts || filterHour== '*'" id="slots">
          <div class="row">
            <div
              class="col-12 col-md-6 col-lg-4 col-xl-3 mb-2"
              v-for="(slot, i) in filtered"
              :key="i"
              :aria-selected="filterHour === slot"
              v-on:click="onSlotSelection(slot)"
              @keyup.enter="onSlotSelection(slot)"
            >
              <a
                @click="filterHour = slot"
                style="width: 90%"
                tabindex="8"
                role="listbox"
                :class="{
                  'btn-upvehu-negro': filterHour === slot,
                  'btn-upvehu-blanco': filterHour !== slot,
                }"
                class="btn btn-raised mx-2 p-1 seleccion-slot"
              >
                <span style="line-height: 2rem; font-size: 95%">{{
                  slot | iso2shortdate
                }}</span>
                <span
                  class="badge bg-secondary py-1 px-2 mt-1 float-right"
                  style="font-size: 115%"
                  >{{ slot | iso2time }}
                </span>
              </a>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <NavButton anterior="PersonalData" title="anterior" />
  </div>
</template>
<script>
import Breadcrumb from "../components/Breadcrumb";
import HeadingBox from "../components/HeadingBox";
import DatosIntroducidos from "../components/DatosIntroducidos";

import Vue from "vue";
import Spinner from "@/components/Spinner.vue";
import AlertaError from "@/components/AlertaError.vue";
import NavButton from "@/components/NavButton.vue";
import APIPortal from "@/services/APIPortal.js";
import APIPWA from "@/services/APIPWA.js";
import Utils from "@/services/Utils.js";
import Session from "@/session/Session.js";

export default {
  name: "SelectSlot",
  components: {
    Breadcrumb,
    HeadingBox,
    DatosIntroducidos,
    AlertaError,
    Spinner,
    NavButton,
  },
  computed: {
    filtered() {
      let byday =
        this.slots.filter((s) => {
          return s.indexOf(this.filterDay || "-") > -1;
        }) || [];

      // window.console.log('byday>', byday)
      if (!this.filterHour || !this.filterHour.starts) return byday;

      return byday.filter((s) => {
        let h = s.split("T")[1].split("+")[0];
        h = h.split(":")[0];
        // window.console.log('s>', s, h)
        window.console.log(
          "this.filterHour.starts>",
          this.filterHour.starts,
          this.filterHour.ends,
          h
        );
        return this.filterHour.starts <= h && this.filterHour.ends > h;
      });
    },
  },
  data: () => ({
    Session,
    slots: [],
    days: [],
    queue: Session.getQueue(),
    servicePoint: Session.getServicePoint(),
    filterDay: null,
    filterHour: {},
    hourFilters: [
      { label: "Todas", starts: "00", ends: 25 },
      { label: "Antes de las 11:00", starts: "00", ends: 11 },
      { label: "De 11:00 a 16:00", starts: 11, ends: 16 },
      { label: "Despues de las 16:00", starts: 16, ends: 25 },
    ],

    dayCounts: {},
    hourCounts: {},

    loading: false,
  }),
  async mounted() {
    if (!Session.getServicePoint()) {
      this.$router.push({ name: 'Home' });
      return
    }
    window.console.log("t>", this.$t("selectslot.todas"));
    this.hourFilters[0].label = this.$t("selectslot.todas");
    this.hourFilters[1].label = this.$t("selectslot.antesdelas");
    this.hourFilters[2].label = this.$t("selectslot.dea");
    this.hourFilters[3].label = this.$t("selectslot.despuesdelas");

    window.console.log(
      "sesion>",
      Session,
      Session.getQueue(),
      Session.getServicePoint()
    );
    var queueID = Session.getQueue().id;
    var serviceID = Session.getServicePoint().id;
    var channelID = Session.getServiceChannel().id;

    this.loading = true;
    let res = null
    try {
      res = await APIPortal.findSlots(queueID, serviceID, channelID);
    } catch(err) {
      window.console.log("err>", err);
      this.loading = false;
      return
    }

    this.loading = false;


    this.days = window
      ._(res.data)
      .map((s) => s.split("T")[0])
      .uniq()
      .sort()
      .value();

    window.console.log("this.days>", this.days);
    Vue.set(this, "dayCounts", {});

    window._(res.data).each((s) => {
      let k = s.split("T")[0];
      window.console.log("k>", k);
      this.dayCounts[k] = (this.dayCounts[k] || 0) + 1;
    });
    window.console.log("count>", this.dayCounts);
    this.slots = res.data;
  },
  methods: {
    setFilterHour(s) {
      this.filterHour = s
      Utils.scrollTo('slots')
    },
    hourBetween(slot, starts, ends) {
      if (!slot) return false;
      window.console.log("hourBetween>", slot, starts, ends);
    },
    setFilterDay(df) {
      this.filterDay = df;
      this.filterHour = {};

      // df> 2020-07-23
      window.console.log("df>", df);

      // guarda las citas para la fehca seleccionada df
      let filteredByDay = window
        ._(this.slots)
        .filter((s) => {
          // window.console.log('df, s', df, s)
          return s.split("T")[0] === df;
        })
        .value();

      window.console.log("filteredByDay>", filteredByDay);
      if ( (filteredByDay || []).length && (filteredByDay || []).length < 10) {
        this.filterHour = '*'
      }

      let hours = window
        ._(filteredByDay)
        .map((s) => s.split("T")[1])
        .map((s) => s.split(":")[0])
        .uniq()
        .sort()
        .value();
      window.console.log("hours>", hours);

      // this.hourFilters = [{ label: "Todas", starts: "00", ends: 25 }];
      this.hourFilters = [];

      let add = window
        ._(hours)
        .map((h) => {
          return { label: h + ":00", starts: +h, ends: +h + 1 };
        })
        .value();
      window.console.log("add>", add);

      this.hourFilters = this.hourFilters.concat(add);

      // this.filterHour = this.hourFilters[0];

      Vue.set(this, "hourCounts", {});
      window._(filteredByDay).each((s) => {
        // hourCounts s> 2020-07-22T12:35:00+02:00
        // window.console.log('hourCounts s>', s)
        let h = s.split("T")[1].split(":")[0];
        h = +h;
        this.hourCounts[h] = (this.hourCounts[h] || 0) + 1;
      });
      window.console.log("this.hourCounts>", this.hourCounts);
      Utils.scrollTo('horas')
    },
    async onSlotSelection(s) {
      var t = Object.assign(
        {
          queue: { id: Session.getQueue().id },
          servicePoint: { id: Session.getServicePoint().id },
          issueChannel: { id: Utils.PORTAL_CHANNEL },
          serviceChannel: { id: Session.getServiceChannel().id },
          scheduledServiceTime: s,
          comments: Session.getComments()
        },
        Session.getVisitor()
      );

      try {
        this.loading = true;
        let v = Session.getVisitor();

        if (v.notificacionesPush)
          t.webPushPermissionToken = JSON.stringify(APIPWA.webPushSubscription);
        v.notificacionesPush = null;

        let res = await APIPortal.issueTicket(t);
        this.loading = false;

        Utils.muestraTicketEmitido(res.data)
      } catch (e) {
        this.loading = false;
        window.console.log("err>", e);
      }
    },
  },
};
</script>

<style>
.queue {
  color: white;
  background-color: #37474f;
}

.truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.font75pct {
  font-size: 80%;
}
</style>
